import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  ownerInputModal: {
    maxHeight: 'calc(100vh - 100px)',
    maxWidth: 'calc(100vw - 60px)',
    minHeight: '48vh',
    minWidth: '50vh',
    borderRadius: SPACES.xxxxxxxl,
    padding: SPACES.m,
  },
  ownerInputModalTablet: {
    // height: '40vh',
    width: '90vw',
    borderRadius: SPACES.xxxxxxxl,
    padding: SPACES.m,
  },
  ownerInputModalDelete: {
    maxHeight: 'calc(100vh - 100px)',
    maxWidth: 'calc(100vw - 60px)',
    minHeight: '20vh',
    minWidth: '30vh',
    borderRadius: SPACES.xxxxxxxl,
    padding: SPACES.m,
  },
  ownerInputModalTabletDelete: {
    height: '20vh',
    width: '90vw',
    borderRadius: SPACES.xxxxxxxl,
    padding: SPACES.m,
  },
  modal: {
    minHeight: '40vh',
    maxHeight: 'calc(100vh - 100px)',
    gap: SPACES.xxxl,
    marginTop: SPACES.xxxl,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  modalTablet: {
    gap: SPACES.xxxl,
    marginTop: SPACES.xxxl,
    maxHeight: 'calc(100vh - 100px)',
    minHeight: '40vh',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalDelete: {
    minHeight: '20vh',
    maxHeight: 'calc(100vh - 100px)',
    gap: SPACES.xxxl,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  modalTabletDelete: {
    gap: SPACES.xxxl,
    height: '20vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mainBlock: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
